export default "__VITE_PUBLIC_ASSET__d90af078__"